import request from 'superagent';

import { REPORTS_URL } from 'constants/Jaws';

export function fetchMetadata(type) {
  return request.get(`${REPORTS_URL}/metadata`).query({ type });
}

export function mapOperation(input) {
  return (
    {
      0: 'Ny',
      1: 'Endret',
      2: 'Slettet',
    }[input] || '-'
  );
}
